<template>
    <input
        :value="value"
        type="text"
        :placeholder="placeholder"
        :disabled="disabled"
        @keyup="onPhoneInput"
    />
</template>
<script>
export default {
    name: "Button",
    props: {
        value: String,
        disabled: Boolean,
        strAble: Boolean,
        placeholder: String
    },
    computed: {

    },
    methods: {
        onPhoneInput(ev) {
            if (!this.strAble) {
                this.onlyPhoneNumber(ev);
            }

            if (ev.keyCode === 13) {
                this.$listeners.keyup && this.$listeners.keyup(ev);
                return;
            }

            const value = this.autoComplatePhonePattern(ev.target.value);
            this.$emit("input", value);
        },

        onlyPhoneNumber(ev) {
            const {value} = ev.target;
            const pattern = /^[0-9|\-]+$/g;

            if (pattern.test(value) || value === "") {
                this.$emit("input", value);
                return;
            } else {
                this.$emit("input", "");
                ev.target.value = "";
            }

            if (/^[a-zA-Z가-힣]+/g.test(value)) {
                ev.target.value = "";
            }
        },

        autoComplatePhonePattern(value) {
            if (/^0[3-6][1-5]$/.test(value)) {
                value += "-";
            }

            if (/^(02|070)$/.test(value)) {
                value += "-";
            }

            if (/^(01[0-9])$/.test(value)) {
                value += "-";
            }

            if (/^(01[0-9]|0[3-6][1-5]|02|070)\-[0-9]{3,4}$/.test(value)) {
                value += "-";
            }

            if (/^(01[0-9]|0[3-6][1-5]|02|070)\-[0-9|\-]{9}$/.test(value)) {
                if (/^(02)/.test(value)) {
                    value = value
                        .replace(/\-/g, "")
                        .replace(/^(\d{2})(\d{4})(\d{4})$/, "$1-$2-$3");
                } else {
                    value = value
                        .replace(/\-/g, "")
                        .replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
                }
            }

            return value;
        }
    },
    watch: {
        value(newValue) {
            if (/[0-9]+/.test(newValue)) {
                const value = newValue.replace(
                    /(\d{3})(\d{4})(\d{4})/g,
                    "$1-$2-$3"
                );
                this.$emit("input", value);
            }
        }
    }
};
</script>

<style scoped lang="scss">

</style>